// extracted by mini-css-extract-plugin
var _1 = "EpostStatusTimelineTrackingStatus-moduleblock__F_R3_";
var _2 = "EpostStatusTimelineTrackingStatus-modulecontent__kA81t Container-modulecontent__hwVr6";
export { _1 as "block", _2 as "content" }
